import { PriorityTypes } from "../enums/PriorityEnum";
import { StatusTypes } from "../enums/StatusEnum";
import { TestCaseTypes } from "../enums/TestCaseTypes";

export const dropdownValidation = (formulae, strict = true) => ({
    type: "list",
    allowBlank: false,
    formulae,
    showInputMessage: true,
    promptTitle: strict ? "Choose from dropdown" : "Choose or type",
    prompt: strict
        ? "Please select only from the given options."
        : "You can select from dropdown or type your own value.",
    showErrorMessage: strict,       // strict blocks typing, non-strict allows
    errorTitle: strict ? "Invalid input" : undefined,
    error: strict
        ? "Please select only from the dropdown list."
        : undefined,
    errorStyle: strict ? "stop" : undefined,
});

export const positiveIntegerValidation = {
    type: "whole",
    operator: "greaterThan",
    formulae: [0],
    allowBlank: false,
    showInputMessage: true,
    promptTitle: "Positive Number",
    prompt: "Please insert value in minutes. Only positive whole numbers are allowed.",
    showErrorMessage: true,
    errorTitle: "Invalid input",
    error: "Only positive whole numbers are allowed.",
};

export const max200CharValidation = {
    type: "textLength",
    operator: "lessThanOrEqual",
    formulae: [200],
    allowBlank: false,
    showInputMessage: true,
    promptTitle: "Title length",
    prompt: "Title cannot exceed 200 characters.",
    showErrorMessage: true,
    errorTitle: "Too Long",
    error: "Title cannot exceed 200 characters.",
};

const convertToDropdownFormat = (options) => [`"${options.join(',')}"`];


export const TYPE_DROPDOWN_VALUES = convertToDropdownFormat(Object.values(TestCaseTypes));
export const STATUS_DROPDOWN_VALUES = convertToDropdownFormat(Object.values(StatusTypes));
export const PRIORITY_DROPDOWN_VALUES = convertToDropdownFormat(Object.values(PriorityTypes));



export const TOTAL_ROWS = 1000;
export const FORMULA_ROWS = 50;
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
